// extracted by mini-css-extract-plugin
export default {"icon":"Devices_icon__TuAQa","container":"Devices_container__04t-F","searchContainer":"Devices_searchContainer__yqqAe"};